import { TestsActions, MCQ_GROUPS } from './constants';
import _ from 'lodash';
import { getVettedSkillsStats, getWorkHistoriesStats } from '../../util/profileCheckUtil';
import getEnv from '../../../services/util/getEnv';
import { TestState } from '../../../v3/legacy_components/UI_V2_Components/tests/constants';

const initialState = {
  loading: false,
  workExpLoading: false,
  turingProfileCompleted: false,
  seniority: null,
  workExpBtnText: null,
  profileCompleted: false,
  workExpCompleted: false,
  isProgrammerRole: true,
  isTechLead: false,
  techLeadStack: null,
  showTechLeadModal: false,
  skipASA: false,
  showTechLeadOneTestLeftModal: false,
  challenges: [],
  core_challenges: [],
  developer_language_challenges: [],
  stackDemands: [],
  allChallenges: [],
  recommendedMCQ: [],
  roles: [],
  acc_anytime: false,
  user_role: null,
  passedAdditionalMCQ: false,
  personal_info: {
    role_type_id: null
  }
};

// This method should be removed after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
export const altenativeMCQReplace = (challenge_list, stackDemands) => {
  /* 3rd SEPT. MCQ ALTERNATIVES DISPLAYING, BY MANIPULATE THE CHALLENGE DATA
  - 1. FIND GROUP OF MCQ WITH THE SAME alt_name NOT NULL
  - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV
  - 3. IF THE ATV GOT timeLeft > 0 OR submit_time, THAT MEANT USER ALREADY TAKEN THIS MCQ
  SO NO NEED TO DO ANYTHING, DELETE THOSE active = 0
  - 4. ELSE (3): FIND ANY MCQ IN active = 0 LIST, IF THERE IS ANY WITH timeLeft > 0 OR submit_time,
  REPLACE THE ATV WITH IT, AND REMOVE ALL OTHERS */
  let stackDemandsUpdated = stackDemands && stackDemands.length ? [...stackDemands] : [];
  const withAltNames = challenge_list.filter(c => c.alt_name).sort();
  const altNames = _.uniq(withAltNames.map(c => c.alt_name));
  const replacements = [];
  const replacementNames = {};

  altNames.forEach(name => {
    const atvs = withAltNames.filter(c => c.alt_name === name && c.active === 1);

    for (const atv of atvs) {
      // Can have multiple active = 1 now
      // atv = atv[0]; /* - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV */
      if (atv.timeLeft > 0 || atv.submit_time) replacements.push(atv);
      else {
        // Removed c.active === 0 condition because we want to keep multiple mcq active
        const takenAltMCQs = withAltNames.filter(c => c.alt_name === name &&
          (c.timeLeft > 0 || c.submit_time));
        if (takenAltMCQs.length === 0) replacements.push(atv);
        else {
          replacements.push({ ...takenAltMCQs[0], active: true }); /* NO NEED RE-SET active: true BUT SAFE */
          stackDemandsUpdated = stackDemandsUpdated.map((sd) => {
            let title = '';
            sd.groups = sd.groups.map((group) => {
              const listMcqUpdated = _.uniq(group.listMCQ.map((mcqId) => mcqId === atv.challenge_id ? takenAltMCQs[0].challenge_id : mcqId));
              const mcqInfo = challenge_list.filter(mcqDetail => listMcqUpdated.find(mcqId => mcqDetail.challenge_id === mcqId));
              title += mcqInfo.map(mcq => mcq.challenge_name).join(' + ');
              return {
                ...group,
                title,
                listMCQ: listMcqUpdated
              };
            });
            return sd;
          });

          replacementNames[takenAltMCQs[0].challenge_name.toLowerCase()] = atv.challenge_name.toLowerCase(); /* IMPROVISE WITH CURRENT CODE */
        }
      }
    }
  });
  _.remove(challenge_list, (c) => c.alt_name);
  challenge_list = _.concat(challenge_list, replacements);

  challenge_list = _.uniqBy(challenge_list, 'challenge_id');

  if (stackDemands && stackDemands.length) {
    return [challenge_list, stackDemandsUpdated];
  } else {
    return challenge_list;
  }
};

// This method should be removed after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
export const alternativeMCQReplaceV1 = (challenge_list, stackDemands) => {
  /* 3rd SEPT. MCQ ALTERNATIVES DISPLAYING, BY MANIPULATE THE CHALLENGE DATA
  - 1. FIND GROUP OF MCQ WITH THE SAME alt_name NOT NULL
  - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV
  - 3. IF THE ATV GOT timeLeft > 0 OR submit_time, THAT MEANT USER ALREADY TAKEN THIS MCQ
  SO NO NEED TO DO ANYTHING, DELETE THOSE active = 0
  - 4. ELSE (3): FIND ANY MCQ IN active = 0 LIST, IF THERE IS ANY WITH timeLeft > 0 OR submit_time,
  REPLACE THE ATV WITH IT, AND REMOVE ALL OTHERS */
  let stackDemandsUpdated =
    stackDemands && stackDemands.length ? [...stackDemands] : [];
  const withAltNames = challenge_list.filter((c) => c.alt_name).sort();
  const altNames = _.uniq(withAltNames.map((c) => c.alt_name));
  const replacements = [];
  const replacementNames = {};

  altNames.forEach((name) => {
    const atvs = withAltNames.filter((c) => c.alt_name === name && c.active);

    for (const atv of atvs) {
      // Can have multiple active = 1 now
      // atv = atv[0]; /* - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV */
      if (atv.state === TestState.COMPLETED) {
        replacements.push(atv);
      } else {
        // Removed c.active === 0 condition because we want to keep multiple mcq active
        const takenAltMCQs = withAltNames.filter(
          (c) => c.alt_name === name && atv.state === TestState.COMPLETED
        );
        if (takenAltMCQs.length === 0) {
          replacements.push(atv);
        } else {
          replacements.push({
            ...takenAltMCQs[0],
            active: true,
          }); /* NO NEED RE-SET active: true BUT SAFE */
          stackDemandsUpdated = stackDemandsUpdated.map((sd) => {
            let title = "";
            sd.groups = sd.groups.map((group) => {
              const listMcqUpdated = _.uniq(
                group.listMCQ.map((mcqId) =>
                  mcqId === atv.challenge_id
                    ? takenAltMCQs[0].challenge_id
                    : mcqId
                )
              );
              const mcqInfo = challenge_list.filter((mcqDetail) =>
                listMcqUpdated.find((mcqId) => mcqDetail.challenge_id === mcqId)
              );
              title += mcqInfo.map((mcq) => mcq.challenge_name).join(" + ");
              return {
                ...group,
                title,
                listMCQ: listMcqUpdated,
              };
            });
            return sd;
          });

          replacementNames[
            takenAltMCQs[0].challenge_name.toLowerCase()
          ] = atv.challenge_name.toLowerCase(); /* IMPROVISE WITH CURRENT CODE */
        }
      }
    }
  });
  _.remove(challenge_list, (c) => c.alt_name);
  challenge_list = _.concat(challenge_list, replacements);

  challenge_list = _.uniqBy(challenge_list, "challenge_id");

  if (stackDemands && stackDemands.length) {
    return [challenge_list, stackDemandsUpdated];
  } else {
    return challenge_list;
  }
};

// This method should be kept after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
export const alternativeMCQReplaceV2 = (challenge_list) => {
  /* 3rd SEPT. MCQ ALTERNATIVES DISPLAYING, BY MANIPULATE THE CHALLENGE DATA
  - 1. FIND GROUP OF MCQ WITH THE SAME alt_name NOT NULL
  - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV
  - 3. IF THE ATV GOT timeLeft > 0 OR submit_time, THAT MEANT USER ALREADY TAKEN THIS MCQ
  SO NO NEED TO DO ANYTHING, DELETE THOSE active = 0
  - 4. ELSE (3): FIND ANY MCQ IN active = 0 LIST, IF THERE IS ANY WITH timeLeft > 0 OR submit_time,
  REPLACE THE ATV WITH IT, AND REMOVE ALL OTHERS */
  const withAltNames = challenge_list.filter((c) => c.alt_name).sort();
  const altNames = _.uniq(withAltNames.map((c) => c.alt_name));
  const replacements = [];
  const replacementNames = {};

  altNames.forEach((name) => {
    const atvs = withAltNames.filter((c) => c.alt_name === name && c.active);

    for (const atv of atvs) {
      // Can have multiple active = 1 now
      // atv = atv[0]; /* - 2. IT SHOULD HAS ONLY ONE active = 1 ==> ATV */
      if (atv.state === TestState.COMPLETED) {
        replacements.push(atv);
      } else {
        // Removed c.active === 0 condition because we want to keep multiple mcq active
        const takenAltMCQs = withAltNames.filter(
          (c) => c.alt_name === name && atv.state === TestState.COMPLETED
        );
        if (takenAltMCQs.length === 0) {
          replacements.push(atv);
        } else {
          replacements.push({
            ...takenAltMCQs[0],
            active: true,
          }); /* NO NEED RE-SET active: true BUT SAFE */

          replacementNames[
            takenAltMCQs[0].challenge_name.toLowerCase()
          ] = atv.challenge_name.toLowerCase(); /* IMPROVISE WITH CURRENT CODE */
        }
      }
    }
  });
  _.remove(challenge_list, (c) => c.alt_name);
  challenge_list = _.concat(challenge_list, replacements);

  challenge_list = _.uniqBy(challenge_list, "challenge_id");
  return challenge_list;
};

const markRecommendedMCQ = (all_mcq, selected_skill_mcq) => {
  // Create a set of challenge_ids from the selected_skill_mcq for quick lookup
  const selectedChallengeIds = new Set(selected_skill_mcq.map(mcq => mcq.challenge_id));

  // Loop through all_mcq and mark recommended based on the presence in selectedChallengeIds
  return all_mcq.map(mcq => ({
    ...mcq,
    recommended: selectedChallengeIds.has(mcq.challenge_id) ? 1 : 0
  }));
};


function TestsReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {

    // This action should be removed after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
    case TestsActions.LOAD_MCQ_CHALLENGES_SUCCESSV1: {
      if (payload) {
        const recommendedMCQ = Array.isArray(payload.recommendedMCQ)
          ? alternativeMCQReplaceV1(payload.recommendedMCQ)
          : state.recommendedMCQ;

        const [challenges, stackDemandsUpdated] = Array.isArray(
          payload.challenges
        )
          ? alternativeMCQReplaceV1(payload.challenges, payload.stackDemands)
          : [state.challenges];
        
        
        const allChallenges = Array.isArray(payload.allChallenges)
          ? alternativeMCQReplaceV1(payload.allChallenges)
          : state.allChallenges;

        payload.recommendedMCQ = recommendedMCQ.map(recMCQ => {
          recMCQ.category_type =
            typeof recMCQ.category_type === 'string'
              ? recMCQ.category_type.trim().toUpperCase()
              : '';
          recMCQ.challengeIds = (typeof recMCQ.challenge_ids === 'string'
            ? recMCQ.challenge_ids
            : ''
          )
            .split(',')
            .map(id => parseInt(id.trim()));
          recMCQ.has = MCQ_Id => recMCQ.challengeIds.includes(parseInt(MCQ_Id));
          return recMCQ;
        });

        const MapMCQ = mcq => {
          mcq.Tags = payload.recommendedMCQ
            .filter(recMCQ => recMCQ.has(mcq.challenge_id))
            .map(recMCQ => recMCQ.category_type)
            .filter(categoryType => typeof categoryType === 'string')
            .map(categoryType => categoryType.toUpperCase());

          // check if is in IN_PROGRESS group
          if (mcq.state === TestState.IN_PROGRESS) {
            mcq.Tags.push(MCQ_GROUPS.IN_PROGRESS);
          }

          // check if is in INTERESTED group
          mcq.tagNames = (typeof mcq.tag_name === 'string' ? mcq.tag_name : '')
            .split(',')
            .map(name => name.trim().toLowerCase());

          if (mcq.tagNames.includes('show_in_interested')) {
            mcq.Tags.push(MCQ_GROUPS.INTERESTED);
          }

          // IF has no group add to OTHER group
          if (!mcq.Tags.length) {
            mcq.Tags.push(MCQ_GROUPS.OTHER);
          }

          return mcq;
        };

        const PRACTICE_MCQ_ID = getEnv('REACT_APP_PRACTICE_MCQ') || null;

        payload.stackDemands = stackDemandsUpdated;
        payload.challenges = (challenges || []).map(MapMCQ);

        payload.allChallenges = allChallenges
          .map(MapMCQ)
          .filter(item => +item.challenge_id !== +PRACTICE_MCQ_ID);

        if (
          payload.isTechLead &&
          Array.isArray(payload.stackDemands) &&
          Array.isArray(challenges)
        ) {
          const techLeadStack = payload.stackDemands.find(
            item =>
              +item.stack_demand_id === +getEnv('REACT_APP_TECHLEAD_STACK_ID')
          );
          if (techLeadStack) {
            payload.techLeadStack = techLeadStack;
            payload.techLeadStack.MCQList = payload.techLeadStack.groups[0].listMCQ.map(
              MCQId => challenges.find(mcq => +mcq.challenge_id === +MCQId)
            );

            const isTechLeadStackPassed = payload.techLeadStack.MCQList.every(
              item => item.passed && item.state === TestState.COMPLETED
            );

            const isTechLeadStackPending = payload.techLeadStack.MCQList.every(
              item =>
                item.state === TestState.TODO ||
                item.state === TestState.IN_PROGRESS
            );

            const techLeadStackPendingCount = payload.techLeadStack.MCQList.filter(
              item =>
                item.state === TestState.TODO ||
                item.state === TestState.IN_PROGRESS
            ).length;

            if (
              isTechLeadStackPending &&
              !localStorage.getItem('HIDE_TECHLEAD_MODAL')
            ) {
              payload.showTechLeadModal = true;
            } else if (
              isTechLeadStackPassed &&
              techLeadStackPendingCount === 1 &&
              !localStorage.getItem('HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL')
            ) {
              payload.showTechLeadOneTestLeftModal = true;
            } else if (
              isTechLeadStackPassed &&
              !!localStorage.getItem('TECHLEAD_MCQ_TAKEN')
            ) {
              payload.techLeadNextStack = payload.stackDemands
                .filter(
                  item =>
                    +item.stack_demand_id !==
                    +getEnv('REACT_APP_TECHLEAD_STACK_ID')
                )
                .map(item => {
                  if (!item.groups || !item.groups.length)
                    return { ...item, MCQList: [] };
                  return {
                    ...item,
                    MCQList: item.groups[0].listMCQ.map(MCQId =>
                      challenges.find(mcq => +mcq.challenge_id === +MCQId)
                    )
                  };
                })
                .find(
                  item =>
                    item.MCQList.length &&
                    item.MCQList.some(mcq => !mcq.submit_time)
                );
              payload.showTechLeadNextStackModel = true;
            }
          }
        } else if (payload.isTechLead === false) {
          payload.showTechLeadModal = false;
          payload.showTechLeadNextStackModel = false;
        }
        if (Array.isArray(payload.stackDemands)) {
          payload.stackDemands.sort((a, b) => {
            if (a.is_hidden && !b.is_hidden) return -1;
            if (!a.is_hidden && b.is_hidden) return 1;
            return a.stack_demand_id > b.stack_demand_id ? 1 : -1;
          });
        }

        if (payload.experience_info && payload.passed_skills) {
          const profileRequirements = {
            allWHCombinedHaveMoreThan500Words: true,
            mentionVettedSkillAtLeast3Times: true,
            atLeast2YOEInAllVettedSkills: true
          };
          const workHistoriesWordCount = getWorkHistoriesStats(
            payload.experience_info
          );
          profileRequirements.allWHCombinedHaveMoreThan500Words =
            workHistoriesWordCount >= 500;
          const {
            vettedSkillsNotReferencedAtLeast3Times,
            vettedSkillsWithLessThan2YOE
          } = getVettedSkillsStats(
            payload.passed_skills,
            payload.experience_info
          );

          if (vettedSkillsNotReferencedAtLeast3Times.length > 0) {
            profileRequirements.mentionVettedSkillAtLeast3Times = false;
          }

          if (vettedSkillsWithLessThan2YOE.length > 0) {
            profileRequirements.atLeast2YOEInAllVettedSkills = false;
          }

          payload.turingProfileCompleted =
            profileRequirements.allWHCombinedHaveMoreThan500Words &&
            profileRequirements.mentionVettedSkillAtLeast3Times &&
            profileRequirements.atLeast2YOEInAllVettedSkills;
        }
      }

      return { ...state, ...payload, loading: false };
    }

    // This action should be kept after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
    case TestsActions.LOAD_MCQ_CHALLENGES_SUCCESSV2: {
      if (payload) {
        // Setting recommendedMCQ as the feature is not being used anymore
        const recommendedMCQ = [];

        const core_challenges = Array.isArray(payload.core_challenges)
          ? alternativeMCQReplaceV2(payload.core_challenges)
          : state.core_challenges;

        const developer_language_challenges = Array.isArray(payload.developer_language_challenges)
          ? payload.developer_language_challenges
          : state.developer_language_challenges;

        const challenges = Array.isArray(
          payload.challenges
        )
          ? alternativeMCQReplaceV2(payload.challenges)
          : state.challenges;

        const allChallenges = Array.isArray(payload.allChallenges)
        ? alternativeMCQReplaceV2(payload.allChallenges)
        : state.allChallenges;

        payload.recommendedMCQ = recommendedMCQ.map(recMCQ => {
          recMCQ.category_type =
            typeof recMCQ.category_type === 'string'
              ? recMCQ.category_type.trim().toUpperCase()
              : '';
          recMCQ.challengeIds = (typeof recMCQ.challenge_ids === 'string'
            ? recMCQ.challenge_ids
            : ''
          )
            .split(',')
            .map(id => parseInt(id.trim()));
          recMCQ.has = MCQ_Id => recMCQ.challengeIds.includes(parseInt(MCQ_Id));
          return recMCQ;
        });

        const MapMCQ = mcq => {
          mcq.Tags = payload.recommendedMCQ
            .filter(recMCQ => recMCQ.has(mcq.challenge_id))
            .map(recMCQ => recMCQ.category_type)
            .filter(categoryType => typeof categoryType === 'string')
            .map(categoryType => categoryType.toUpperCase());

          // check if is in IN_PROGRESS group
          if (mcq.state === TestState.IN_PROGRESS) {
            mcq.Tags.push(MCQ_GROUPS.IN_PROGRESS);
          }

          // check if is in INTERESTED group
          mcq.tagNames = (typeof mcq.tag_name === 'string' ? mcq.tag_name : '')
            .split(',')
            .map(name => name.trim().toLowerCase());

          if (mcq.tagNames.includes('show_in_interested')) {
            mcq.Tags.push(MCQ_GROUPS.INTERESTED);
          }

          // IF has no group add to OTHER group
          if (!mcq.Tags.length) {
            mcq.Tags.push(MCQ_GROUPS.OTHER);
          }

          return mcq;
        };
        payload.core_challenges = core_challenges;
        payload.developer_language_challenges = developer_language_challenges;
        const PRACTICE_MCQ_ID = getEnv('REACT_APP_PRACTICE_MCQ') || null;

        payload.challenges = (challenges || []).map(MapMCQ);
        payload.allChallenges = allChallenges
          .map(MapMCQ)
          .filter(item => +item.challenge_id !== +PRACTICE_MCQ_ID);

        payload.allChallenges = markRecommendedMCQ(payload.allChallenges, payload.challenges);
        const coreMCQChallengeIds = core_challenges.map(ch => ch.challenge_id);
        // Only check for MCQ related to developer selected skills
        const passedAdditionalChallenges = (payload.allChallenges || []).filter(challenge => 
          challenge.passed && challenge.state.toLowerCase() === 'completed' && challenge.recommended && !(coreMCQChallengeIds || []).includes(challenge.challenge_id)
        );
        payload.allChallenges = payload.allChallenges.filter(ch => coreMCQChallengeIds.indexOf(ch.challenge_id) < 0);
        // Check for number of passed Additional MCQ
        payload.passedAdditionalMCQ = passedAdditionalChallenges.length > 0;

        if (payload.experience_info && payload.passed_skills) {
          const profileRequirements = {
            allWHCombinedHaveMoreThan500Words: true,
            mentionVettedSkillAtLeast3Times: true,
            atLeast2YOEInAllVettedSkills: true
          };
          const workHistoriesWordCount = getWorkHistoriesStats(
            payload.experience_info
          );
          profileRequirements.allWHCombinedHaveMoreThan500Words =
            workHistoriesWordCount >= 500;
          const {
            vettedSkillsNotReferencedAtLeast3Times,
            vettedSkillsWithLessThan2YOE
          } = getVettedSkillsStats(
            payload.passed_skills,
            payload.experience_info
          );

          if (vettedSkillsNotReferencedAtLeast3Times.length > 0) {
            profileRequirements.mentionVettedSkillAtLeast3Times = false;
          }

          if (vettedSkillsWithLessThan2YOE.length > 0) {
            profileRequirements.atLeast2YOEInAllVettedSkills = false;
          }

          payload.turingProfileCompleted =
            profileRequirements.allWHCombinedHaveMoreThan500Words &&
            profileRequirements.mentionVettedSkillAtLeast3Times &&
            profileRequirements.atLeast2YOEInAllVettedSkills;
        }
        if (payload.roles && payload.personal_info.role_type_id) {
          const user_role_object = (payload.roles || []).find(role => role.role_id === payload.personal_info.role_type_id);
          if (user_role_object && user_role_object.role_name) {
            payload.user_role = user_role_object.role_name;
          }
        }
      }
      return { ...state, ...payload, loading: false };
    }

    // This action should be removed after the `use_onboarding_improved_ui_ux_multi_variant = v2 and above is 100% rolled out` flag is 100% rolled out
    case TestsActions.LOAD_MCQ_CHALLENGES_SUCCESS: {
      if (payload) {
        const recommendedMCQ = Array.isArray(payload.recommendedMCQ) ? altenativeMCQReplace(payload.recommendedMCQ) : state.recommendedMCQ;
        const [challenges, stackDemandsUpdated] = Array.isArray(payload.challenges) ? altenativeMCQReplace(payload.challenges, payload.stackDemands) : [state.challenges];
        const allChallenges = Array.isArray(payload.allChallenges) ? altenativeMCQReplace(payload.allChallenges) : state.allChallenges;

        payload.recommendedMCQ = recommendedMCQ.map(recMCQ => {
          recMCQ.category_type = typeof recMCQ.category_type === 'string' ? recMCQ.category_type.trim().toUpperCase() : '';
          recMCQ.challengeIds = (typeof recMCQ.challenge_ids === 'string' ? recMCQ.challenge_ids : '').split(',').map(id => parseInt(id.trim()));
          recMCQ.has = MCQ_Id => recMCQ.challengeIds.includes(parseInt(MCQ_Id));
          return recMCQ;
        });

        const MapMCQ = mcq => {
          // mcq.Tags => [ 'TAKE_ONE', 'TAKE_ALL' ]
          mcq.Tags = payload.recommendedMCQ
            .filter(recMCQ => recMCQ.has(mcq.challenge_id))
            .map(recMCQ => recMCQ.category_type)
            .filter(categoryType => typeof categoryType === 'string')
            .map(categoryType => categoryType.toUpperCase());

          // check if is in IN_PROGRESS group
          if (mcq.timeLeft && parseFloat(mcq.timeLeft) > 0) {
            mcq.Tags.push(MCQ_GROUPS.IN_PROGRESS);
          }

          // check if is in INTERESTED group
          mcq.tagNames = (typeof mcq.tag_name === 'string' ? mcq.tag_name : '').split(',').map(name => name.trim().toLowerCase());
          if (mcq.tagNames.includes('show_in_interested')) {
            mcq.Tags.push(MCQ_GROUPS.INTERESTED);
          }

          // IF has no group add to OTHER group
          if (!mcq.Tags.length) {
            mcq.Tags.push(MCQ_GROUPS.OTHER);
          }

          return mcq;
        };
        const WORK_EXP_MCQ_ID = getEnv("REACT_APP_WORK_EXP_MCQ") || null;
        const PRACTICE_MCQ_ID = getEnv("REACT_APP_PRACTICE_MCQ") || null;
        payload.stackDemands = stackDemandsUpdated;
        payload.challenges = (challenges || []).map(MapMCQ); // .filter(item => +item.challenge_id !== +WORK_EXP_MCQ_ID);
        const AccAnytimeMCQ = (challenges || []).map(MapMCQ).filter(item => item.acc_anytime);
        payload.acc_anytime = !!AccAnytimeMCQ.length;
        payload.allChallenges = allChallenges.map(MapMCQ).filter(item => (+item.challenge_id !== +WORK_EXP_MCQ_ID) && (+item.challenge_id !== +PRACTICE_MCQ_ID));
        payload.practiceMcq = allChallenges.find((item) => +item.challenge_id === +PRACTICE_MCQ_ID);

        if (payload.isTechLead && Array.isArray(payload.stackDemands) && Array.isArray(challenges)) {
          const techLeadStack = payload.stackDemands.find(item => +item.stack_demand_id === +getEnv("REACT_APP_TECHLEAD_STACK_ID"));
          if (techLeadStack) {
            payload.techLeadStack = techLeadStack;
            payload.techLeadStack.MCQList = payload.techLeadStack.groups[0].listMCQ
              .filter(MCQId => +MCQId !== +WORK_EXP_MCQ_ID)
              .map(MCQId => challenges.find(mcq => +mcq.challenge_id === +MCQId));
            const isTechLeadStackPassed = payload.techLeadStack.MCQList.every(item => item.passed === 1 && !item.timeLeft);
            const allSubmitedArePassed = payload.techLeadStack.MCQList.every(item => (item.passed === 1 && !item.timeLeft) || !item.submit_time);
            const isTechLeadStackPending = payload.techLeadStack.MCQList.every(item => !item.submit_time);
            const techLeadStackPendingCount = payload.techLeadStack.MCQList.filter(item => !item.submit_time).length;
            if (isTechLeadStackPending && !localStorage.getItem('HIDE_TECHLEAD_MODAL')) {
              payload.showTechLeadModal = true;
            } else if (allSubmitedArePassed && techLeadStackPendingCount === 1 && !localStorage.getItem('HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL')) {
              payload.showTechLeadOneTestLeftModal = true;
            } else if (isTechLeadStackPassed && !!localStorage.getItem('TECHLEAD_MCQ_TAKEN')) {
              payload.techLeadNextStack = payload.stackDemands
                .filter(item => +item.stack_demand_id !== +getEnv("REACT_APP_TECHLEAD_STACK_ID"))
                .map(item => {
                  if (!item.groups || !item.groups.length) return { ...item, MCQList: [] };
                  return { ...item, MCQList: item.groups[0].listMCQ.map(MCQId => challenges.find(mcq => +mcq.challenge_id === +MCQId)) };
                })
                .find(item => item.MCQList.length && item.MCQList.some(mcq => !mcq.submit_time));
              payload.showTechLeadNextStackModel = true;
            }
          }
        } else if (payload.isTechLead === false) {
          payload.showTechLeadModal = false;
          payload.showTechLeadNextStackModel = false;
        }
        if (Array.isArray(payload.stackDemands)) {
          payload.stackDemands.sort((a, b) => {
            if (a.is_hidden && !b.is_hidden) return -1;
            if (!a.is_hidden && b.is_hidden) return 1;
            return a.stack_demand_id > b.stack_demand_id ? 1 : -1;
          });
        }

        if (payload.experience_info && payload.passed_skills) {
          const profileRequirements = {
            allWHCombinedHaveMoreThan500Words: true,
            mentionVettedSkillAtLeast3Times: true,
            atLeast2YOEInAllVettedSkills: true
          };
          const workHistoriesWordCount = getWorkHistoriesStats(payload.experience_info);
          profileRequirements.allWHCombinedHaveMoreThan500Words = workHistoriesWordCount >= 500;
          const { vettedSkillsNotReferencedAtLeast3Times, vettedSkillsWithLessThan2YOE } = getVettedSkillsStats(payload.passed_skills, payload.experience_info);

          if (vettedSkillsNotReferencedAtLeast3Times.length > 0) {
            profileRequirements.mentionVettedSkillAtLeast3Times = false;
          }

          if (vettedSkillsWithLessThan2YOE.length > 0) {
            profileRequirements.atLeast2YOEInAllVettedSkills = false;
          }

          payload.turingProfileCompleted = profileRequirements.allWHCombinedHaveMoreThan500Words && profileRequirements.mentionVettedSkillAtLeast3Times && profileRequirements.atLeast2YOEInAllVettedSkills;
        }
      }
      return { ...state, ...payload, loading: false };
    }
    case TestsActions.LOAD_TAGS_MCQ_FILTER_SUCCESS: {
      const tagsMCQFilter = [];
      if (!payload) {
        payload.tagsMCQFilter = tagsMCQFilter;
      }
      return { ...state, ...payload, loading: false };
    }
    case TestsActions.START_LOADING:
      return { ...state, loading: true };
    case TestsActions.END_LOADING:
      return { ...state, loading: false };
    case TestsActions.START_WORK_EXP_MCQ_LOADING: {
      return { ...state, workExpLoading: true };
    }
    case TestsActions.HIDE_TECHLEAD_MODAL: {
      localStorage.setItem('HIDE_TECHLEAD_MODAL', 'true');
      return { ...state, showTechLeadModal: false };
    }
    case TestsActions.HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL: {
      localStorage.setItem('HIDE_TECHLEAD_ONE_TEST_LEFT_MODAL', 'true');
      return { ...state, showTechLeadOneTestLeftModal: false };
    }
    case TestsActions.HIDE_TECHLEAD_NEXTSTACK_MODEL: {
      localStorage.removeItem('TECHLEAD_MCQ_TAKEN');
      return { ...state, showTechLeadNextStackModel: false };
    }
    case TestsActions.LOAD_WORK_EXP_MCQ: {
      const data = payload;
      let btnStatus = null;
      let completed = state.workExpCompleted;
      if (!state.skipASA && (!data || (data && !data.submit_time) || (data && data.submit_time && data.timeleft > 0))) {
        if (data && data.timeleft === 0) btnStatus = 'Start now';
        if (data && data.timeleft > 0) btnStatus = 'Continue';
        /* 4th JAN 2021: WHAT IF timeleft < 0? */
        else if (data && data.passed !== 3 && data.timeLeft < 0) completed = true;
      } else completed = true;

      return { ...state, workExpBtnText: btnStatus, workExpCompleted: completed, isProgrammerRole: data.isProgrammerRole };
    }
    case TestsActions.END_WORK_EXP_MCQ_LOADING: {
      return { ...state, workExpLoading: false };
    }
    case TestsActions.GET_SENIORIY_LEVEL: {
      const seniority = localStorage.getItem('seniority');
      return { ...state, seniority };
    }

    case TestsActions.REMOVE_SENIORITY_LEVEL: {
      localStorage.removeItem('seniority');
      return { ...state };
    }

    case TestsActions.CLOSE_WORK_EXP_MODAL: {
      localStorage.removeItem('seniority');
      return { ...state, seniority: null };
    }

    case TestsActions.LOAD_PROFILE_COMPLETE_STATUS: {
      return { ...state, profileCompleted: payload };
    }
    case TestsActions.RESET_DATA: {
      return { ...initialState };
    }
    default:
      return state;
  }
}


export default TestsReducer;
